import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/images/icon_add.png'


const _hoisted_1 = { class: "user-select" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "选择角色", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "user-select-modal__bd" }

export function render(_ctx, _cache) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_tabs = _resolveComponent("a-tabs")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["user-content", {'disabled':_ctx.disabled}])
        }, [
          _createElementVNode("div", {
            class: "user-list",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
          }, [
            (!_ctx.selectedRoles.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "请选择"))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedRoles, (role) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    disabled: _ctx.disabled,
                    key: role.id,
                    closable: !_ctx.disabled,
                    color: "blue",
                    onClose: _withModifiers($event => (_ctx.deleteSelectedUser(role.id)), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      (role.name.length<10)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(role.name), 1))
                        : (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 1,
                            title: role.name,
                            class: "append-to-body"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(role.name.slice(0,9)+'...'), 1)
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                    ]),
                    _: 2
                  }, 1032, ["disabled", "closable", "onClose"]))
                }), 128))
          ]),
          (_ctx.selectedRoles.length < _ctx.maxCount)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "add-icon",
                type: "link",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
              }, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      class: "user-select-modal user-mod",
      width: "820px",
      onCancel: _ctx.cancelFn,
      onOk: _ctx.ok
    }, {
      title: _withCtx(() => [
        _hoisted_6,
        (_ctx.maxCount && _ctx.maxCount !== Infinity)
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, "本次操作最多可选 " + _toDisplayString(_ctx.maxCount) + " 个角色", 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[3] || (_cache[3] = $event => ((_ctx.activeKey) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "2",
                tab: "组织内角色",
                "force-render": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_table_wrapper, {
                    ref: "tableRef",
                    dataSource: _ctx.rolesData,
                    onOnSelectionChange: _ctx.onSelectionChange,
                    tableHeight: 500,
                    loading: _ctx.loading,
                    columns: _ctx.columns
                  }, null, 8, ["dataSource", "onOnSelectionChange", "loading", "columns"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}